/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTrophyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-trophy"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.5 10.7L6.5 6.9L4.85 6.9Q4.85 6.9 4.85 6.9Q4.85 6.9 4.85 6.9L4.85 7.9Q4.85 8.78 5.29 9.53Q5.72 10.28 6.5 10.7ZM17.5 10.7Q18.27 10.28 18.71 9.53Q19.15 8.78 19.15 7.9L19.15 6.9Q19.15 6.9 19.15 6.9Q19.15 6.9 19.15 6.9L17.5 6.9ZM10.68 19.15L10.68 16.35Q9.5 16.05 8.54 15.35Q7.58 14.65 7.05 13.55Q4.92 13.35 3.56 11.71Q2.2 10.07 2.2 7.9L2.2 6.9Q2.2 5.78 2.96 5.01Q3.73 4.25 4.85 4.25L6.5 4.25L6.5 4.25Q6.5 3.4 7.1 2.8Q7.7 2.2 8.55 2.2L15.45 2.2Q16.3 2.2 16.9 2.8Q17.5 3.4 17.5 4.25L17.5 4.25L19.15 4.25Q20.27 4.25 21.04 5.01Q21.8 5.78 21.8 6.9L21.8 7.9Q21.8 10.07 20.44 11.71Q19.07 13.35 16.95 13.55Q16.43 14.65 15.46 15.35Q14.5 16.05 13.32 16.35L13.32 19.15L16.6 19.15Q17.15 19.15 17.54 19.54Q17.93 19.93 17.93 20.48Q17.93 21.02 17.54 21.41Q17.15 21.8 16.6 21.8L7.4 21.8Q6.85 21.8 6.46 21.41Q6.08 21.02 6.08 20.48Q6.08 19.93 6.46 19.54Q6.85 19.15 7.4 19.15Z" fill={color} />
    </svg>
  );
}
